<template>
	<div class="mainWrapper products">
		<b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
		<h1>Export Products</h1>

		<div class="links">
			<b-button type="is-info"
				><router-link to="/products">
					Products
				</router-link></b-button
			>
		</div>

		<div class="general-search">
			<div>
				<b-autocomplete
					v-model="brandSuggestions"
					:data="filteredBrands"
					:open-on-focus="true"
					placeholder="Brands (Optional)"
					field="name"
					@select="option => (selectedBrand = option)"
					class="brandAutocomplete"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>
			</div>

			<div>
				<b-button type="is-info" @click="exportProducts()">Export</b-button>
			</div>
		</div>

		<div v-if="progress > 0">
			<br /><br />
			<b-progress :value="Math.ceil(progress)" show-value format="percent" type="is-success" size="is-medium"></b-progress>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Products',
	data: function() {
		return {
			limit: 20,
			isLoading: false,
			brands: [], // To store brands
			allBrands: [],
			selectedBrand: null,
			brandSuggestions: '',
			products: [],
			totalLoop: 0,
			progress: 0
		}
	},

	mounted: async function() {
		await this.getBrands()

		const data = {
			populate: ['suppliers']
		}

		const apiGetWarehouse = await this.$api.getWarehouse({ data })

		this.supplier = apiGetWarehouse.data.suppliers[0]._id

		// Get brands name which are related to this warehouse
		await Promise.all(
			apiGetWarehouse.data.suppliers[0].brand.map(async brand => {
				const brandData = {
					id: brand
				}

				const apiGetBrand = await this.$api.getBrand({ data: brandData })

				if (apiGetBrand !== undefined) {
					this.brands.push(apiGetBrand.data.list[0])
				}
			})
		)
	},

	computed: {
		filteredBrands() {
			return this.brands.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.brandSuggestions.toLowerCase()) >= 0
				)
			})
		}
	},

	methods: {
		exportProducts: async function() {
			// Set default data
			this.products = []
			this.isLoading = true
			this.totalLoop = 0
			this.progress = 0

			// Set parameters for API
			var data = {
				limit: 1
			}

			if (this.selectedBrand && this.selectedBrand._id) {
				data.products = {
					brand: this.selectedBrand._id
				}
			}

			const apiGetProducts = await this.$api.getProducts({ data })

			// Loop to get all data
			if (apiGetProducts) {
				const total = apiGetProducts.data.total
				const totalLoop = Math.ceil(apiGetProducts.data.total / this.limit)

				this.totalLoop = total

				var i

				for (i = 0; i < totalLoop; i++) {
					const skip = i * this.limit

					this.progress = (skip / total) * 100

					const result = await this.getProductsLoop(skip)

					result.map(item => {
						this.products.push(item)
					})
				}

				this.progress = 100
			} else {
				this.$swal.fire({
					icon: 'info',
					title: 'No Data...',
					text: 'Sorry, no data found'
				})

				this.isLoading = false

				return
			}

			// To generate the CSV
			if (this.products.length > 0) {
				let finalData = ''

				// Header
				finalData +=
					'BD CODE,BARCODE,NAME,BRAND NAME,BRAND CODE,PURCHASE PRICE,SELLING PRICE,COMMISSION,PRODUCT CODE,STOCK,DAMAGED,EXPIRED,TESTER,CREATED AT\r\n'

				// Loop all items
				this.products.map(item => {
					const product = item.product

					const matchedBrand = this.allBrands.filter(brand => {
						return brand._id == product.brand
					})

					const toAdd = [
						product.bd_code,
						product.barcode,
						'"' + product.name + '"',
						matchedBrand[0].name,
						matchedBrand[0].code,
						product.original_price,
						product.price,
						product.commission,
						product.product_code,
						item.stock,
						item.damaged ? item.damaged : 0,
						item.expired ? item.expired : 0,
						item.tester ? item.tester : 0,
						this.convertTime(item.createdAt)
					]

					let row = toAdd.join(',')

					finalData += row + '\r\n'
				})

				let filename_date = this.$moment().format('DDMMYYhhmmss')

				var csvData = new Blob([finalData], { type: 'text/csv' }) //new way
				var csvUrl = URL.createObjectURL(csvData)

				var link = document.createElement('a')
				link.setAttribute('href', csvUrl)
				link.setAttribute('download', 'Export_Warehouse_Products_' + filename_date + '.csv')
				document.body.appendChild(link) // Required for FF

				this.isLoading = false

				link.click()
				link.remove()

				this.isLoading = false
			}
		},

		// To loop all the products
		getProductsLoop: async function(skip = 0) {
			var data = {
				skip,
				limit: this.limit,
				populate: ['product']
			}

			if (this.selectedBrand && this.selectedBrand._id) {
				data.products = {
					brand: this.selectedBrand._id
				}
			}

			const apiGetProducts = await this.$api.getProducts({ data })

			return apiGetProducts.data.list
		},

		// Get all the brands
		getBrands: async function() {
			const data = {
				limit: 1000,
				sort: {
					name: 'asc'
				}
			}
			const apiGetBrands = await this.$api.getBrand({ data })

			if (apiGetBrands !== undefined) {
				this.allBrands = apiGetBrands.data.list
			}
		},

		// Convert time
		convertTime: function(time) {
			return this.$moment(time).format('DD/MM/YY hh:mm a')
		}
	}
}
</script>

<style scoped>
@import '../styles/Products.css';
</style>
